<template>
  <div>
    <v-layout row wrap>
    <v-flex xs12 sm4>
      <v-btn color="success" small xs2>
        <v-icon small left dark>fas fa-plus</v-icon>
        <span>Agregar</span>
      </v-btn>
    </v-flex>
    </v-layout>

    <ag-grid-vue v-if="showGrid" style="width: 100%;height: 250px" class="ag-theme-material elevation-1"
      :gridOptions="gridOptions" :rowData="registros" :columnDefs="columnDefs">
    </ag-grid-vue>

    <v-dialog v-model="historialDetalle" max-width="550px">
      <v-card>
        <v-card-title>
          <span>Historial</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          Formulario
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="historialDetalle=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import Vue from 'vue'
import DateFormatComponent from '../shared/DateFormatComponent'
import helper from '../../plugins/helper'
import VehiculoHistorial from '../../services/vehiculoHistorial'
import {AgGridVue} from 'ag-grid-vue';

//Vue.use(AgGridVue)

export default {
  name: 'VehiculoHistorialLista',
  props: ['vehiculo'],
  data () {
    return {
      registros: null,
      loading: true,
      gridOptions: {
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        pagination: true,
        localeText: helper.localeText,
      },
      columnDefs: null,
      showGrid: false,
      historialDetalle: false,
      selectedHistorial: null
    }
  },
  components: {
    'ag-grid-vue': AgGridVue,
    'options-component': {
        template: `<div>
        <v-btn icon flat @click="historialDetalle=true" class="mx-0">
        <v-icon small color="error">fas fa-trash</v-icon>
        </v-btn>
        <v-btn icon flat @click="historialDetalle=true" class="mx-0">
        <v-icon small color="primary">fas fa-book</v-icon>
        </v-btn>
        </div>`
    }
  },
  methods: {
    createColumnDefs() {
      this.columnDefs= [
        {
          headerName:  ' ',
          cellRendererFramework: 'options-component',
          cellRendererParams: { modulo: 'vehiculos' },
          width: 100
        },
        {
          headerName: 'Usuario',
          field: 'usuarioCreacion.username',
          width: 150
        },
        {
          headerName: 'Mensaje',
          field: 'mensaje',
          width: 550
        },
        {
          headerName: 'Fecha',
          field: 'fechaCreacion',
          cellRendererFramework: DateFormatComponent,
          width: 150
        }
      ]
      this.showGrid = true;
    }
  },
  async beforeMount() {
    this.registros = await VehiculoHistorial.list({ populate: 'usuarioCreacion', vehiculo: this.vehiculo})
    this.createColumnDefs();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vehiculos/VehiculoHistorialLista.vue